"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  fleetCheckReducer: true
};
Object.defineProperty(exports, "fleetCheckReducer", {
  enumerable: true,
  get: function get() {
    return _fleetCheck2["default"];
  }
});

var _fleetCheck = require("./fleet-check.actions");

Object.keys(_fleetCheck).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _fleetCheck[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fleetCheck[key];
    }
  });
});

var _fleetCheck2 = _interopRequireDefault(require("./fleet-check.reducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }